import script from "./footerImages.vue?vue&type=script&setup=true&lang=ts"
export * from "./footerImages.vue?vue&type=script&setup=true&lang=ts"

import "./footerImages.vue?vue&type=style&index=0&id=01d13ad4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d13ad4"]])

export default __exports__